<template>
  <a-locale-provider :locale="locale">
    <div id="app">
      <router-view :key="activeDate"/>
    </div>
  </a-locale-provider>
</template>

<script>
import zhCN from 'ant-design-vue/lib/locale-provider/zh_CN'
import enUS from 'ant-design-vue/lib/locale-provider/en_US'
import { deviceEnquire, DEVICE_TYPE } from '@/utils/device'
export default {
  data () {
    return {
      lang: {
        'zh_CN': zhCN,
        'en_US': enUS
      },
      activeDate: new Date().getTime(),
      locale: zhCN
    }
  },
  computed: {
    renderLocale: {
      // console.log(cookie.get('is-rpa-lang') || localStorage.getItem('lang'))
      get () {
        return this.lang[this.$store.getters.lang] || zhCN
      },
      set (val) {
        this.locale = this.lang[val]
      }
    }
  },
  watch: {
    '$i18n.locale' (newVal, oldVal) {
      // console.log(newVal)
      this.renderLocale = newVal
      // 通过改变router-view中的key来达到刷新组件的目的
      this.activeDate = new Date().getTime()
      // 设置网页标题
      document.title = this.$t('htmlTit')
    }
  },
  created () {
    // console.log(cookie.get('is-rpa-lang') || 'zh_CN')
    this.locale = this.lang[this.$store.getters.lang] || zhCN
    // 设置国际化网页标题
    document.title = this.$t('htmlTit')
  },
  mounted () {
    const { $store } = this
    // 设置国际化语言，并修改网页的国际化标题
    $store.dispatch('SetLang', this.$store.getters.lang || 'zh_CN')
    deviceEnquire(deviceType => {
      switch (deviceType) {
        case DEVICE_TYPE.DESKTOP:
          $store.commit('TOGGLE_DEVICE', 'desktop')
          $store.dispatch('setSidebar', true)
          break
        case DEVICE_TYPE.TABLET:
          $store.commit('TOGGLE_DEVICE', 'tablet')
          $store.dispatch('setSidebar', false)
          break
        case DEVICE_TYPE.MOBILE:
        default:
          $store.commit('TOGGLE_DEVICE', 'mobile')
          $store.dispatch('setSidebar', true)
          break
      }
      // console.log('deviceType', deviceType)
    })
  },
  methods: {
  }
}
</script>
<style>
  #app {
    height: 100%;
    min-width: 1200px;
  }
</style>
